import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import ProtectionInfoCard from './components/protectionInfoCard/ProtectionInfoCard'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import protectionsApi from 'screens/Protection/protection.api'
import ProtectionInfoGrade from './components/protectionInfoGrade/ProtectionInfoGrade'
import { ITeamReviewFormResponse, ITeamSubmitReviewDto } from 'screens/Protection/protection.types'
import eventBus from 'services/eventBus'

const TeamGradeExpertPage = () => {
  const { wait } = useHttpLoader()
  const params = useParams()

  const [data, setData] = useState<ITeamReviewFormResponse | null>(null)

  const [values, setValues] = useState<Record<string, number>>({})

  useEffect(() => {
    if (!params.teamId || !params.id) return

    wait(protectionsApi.getTeamReviewForm(Number(params.teamId), params.id), (resp) => {
      if (resp.status !== 'success') return

      setData(resp.body)

      setValues(Object.fromEntries(resp.body.criteria.map((c) => [c.id, c.currentValue ?? 0])))
    })
  }, [params.teamId, params.id])

  if (!data) return null

  const handleSubmitReview = async (payload: ITeamSubmitReviewDto) => {
    wait(protectionsApi.submitTeamReviewForm(payload), (resp) => {
      if (resp.status != 'success') return

      eventBus.pub('ntf.message', { message: 'Оценки успешно сохраненны', type: 'info' })
    })
  }

  return (
    <TopNavigationLayoutPageContent type='defaultWithBackButton'>
      <div className='flex-space-between'>
        <h2 className='text--heading-h4' style={{ marginBottom: '1rem' }}>
          Оценка команды
        </h2>
      </div>

      <div style={{ gap: '16px', display: 'flex', flexDirection: 'column' }}>
        <ProtectionInfoCard data={data} values={values} />

        <ProtectionInfoGrade data={data} values={values} setValues={setValues} onSubmit={handleSubmitReview} />
      </div>
    </TopNavigationLayoutPageContent>
  )
}

export default TeamGradeExpertPage
